import React from "react";
import { useTranslation } from 'react-i18next';

function InfoModal({ modalContent, showInfoModal }) {
    const { t } = useTranslation();
    const { title, message } = modalContent || {
        title: t('Information'),
        message: t('No details available.'),
    };

    return (
        <>
            <div className={`modal ${showInfoModal ? 'show' : ''}`} style={{ display: showInfoModal ? 'block' : 'none' }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content modal_content info_modal bg-secondary p-3 pb-4">
                        <div className="modal-body p-0">
                            <h4 className='fw-bold mb-3 text-white text-center'>{title}</h4>
                            <p className='text-light mb-0'>{message}</p>
                        </div>
                    </div>
                </div>
            </div>
            {(showInfoModal) && <div className="modal-backdrop show"></div>}
        </>
    );
}

export default InfoModal;
